import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
// AUTH
import Login from './pages/auth/Login';

// MANTENIMIENTOS - ALIMENTACIÓN
import MantenimientoComedores from './pages/mantenimientos/alimentacion/MantenimientoComedores';
import MantenimientoHomologacionExcel from './pages/mantenimientos/alimentacion/MantenimientoHomologacionExcel';
import MantenimientoLectoras from './pages/mantenimientos/alimentacion/MantenimientoLectoras';
import MantenimientoComensales from './pages/mantenimientos/alimentacion/MantenimientoComensales';
import MantenimientoTipoServiciosAlimentacion from './pages/mantenimientos/alimentacion/MantenimientoTipoServiciosAlimentacion';
import MantenimientoTipoServiciosComedor from './pages/mantenimientos/alimentacion/MantenimientoTipoServiciosComedor';
import MantenimientoTiposOrigenTrabajadores from './pages/mantenimientos/alimentacion/MantenimientoTiposOrigenTrabajadores';
import MantenimientoTiposServiciosAlimentacionOrigen from './pages/mantenimientos/alimentacion/MantenimientoTiposServiciosAlimentacionOrigen';
import MantenimientoComedorLectoresOffline from './pages/mantenimientos/alimentacion/MantenimientoComedorLectoresOffline';

// MANTENIMIENTOS - HOTELERÍA
import MantenimientoZonas from './pages/mantenimientos/hoteleria/MantenimientoZonas';
import MantenimientoModulos from './pages/mantenimientos/hoteleria/MantenimientoModulos';
import MantenimientoTiposValorizacionHoteleria from './pages/mantenimientos/hoteleria/MantenimientoTiposValorizacionHoteleria';
import MantenimientoParametriaModulos from './pages/mantenimientos/hoteleria/MantenimientoParametriaModulos';
import MantenimientoHabitaciones from './pages/mantenimientos/hoteleria/MantenimientoHabitaciones';
import MantenimientoCamas from './pages/mantenimientos/hoteleria/MantenimientoCamas';
import MantenimientoTrabajadoresHoteleria from './pages/mantenimientos/hoteleria/MantenimientoTrabajadoresHoteleria';
import MantenimientoParametriaCamposTrabajadores from './pages/mantenimientos/hoteleria/MantenimientoParametriaCamposTrabajadores';
import MantenimientoEstructuraTicket from './pages/mantenimientos/hoteleria/MantenimientoEstructuraTicket';
import EstacionesImpresion from './pages/mantenimientos/hoteleria/EstacionesImpresion';

// MANTENIMIENTOS GENERALES
import MantenimientoClientes from './pages/mantenimientos/negocio/MantenimientoClientes';
import MantenimientoProyectos from './pages/mantenimientos/negocio/MantenimientoProyectos';
import MantenimientoProyectosClientes from './pages/mantenimientos/negocio/MantenimientoProyectosClientes';
import MantenimientoUsuarios from './pages/mantenimientos/MantenimientoUsuarios';
import MantenimientoUsuariosProyectos from './pages/mantenimientos/MantenimientoUsuariosProyectos';
import MantenimientoParametrosGenerales from './pages/mantenimientos/generales/MantenimientoParametrosGenerales';
import MantenimientoEmpresa from './pages/mantenimientos/generales/MantenimientoEmpresa';
// CORPORATIVO - SEGURIDAD
import GestionRoles from './pages/corporativo/seguridad/GestionRoles';
import PermisosRoles from './pages/corporativo/seguridad/PermisosRoles';
import MenusRoles from './pages/corporativo/seguridad/MenusRoles';
import AsignarRolesUsuarios from './pages/corporativo/seguridad/AsignarRolesUsuarios';

// MANTENIMIENTOS - PLANIFICACIÓN DE INSUMOS
import MantenimientoFamiliasInsumos from './pages/mantenimientos/planificacion/MantenimientoFamiliasInsumos';
import MantenimientoSubfamiliasInsumos from './pages/mantenimientos/planificacion/MantenimientoSubfamiliasInsumos';
import MantenimientoUnidadesMedida from './pages/mantenimientos/planificacion/MantenimientoUnidadesMedida';
import MantenimientoInsumos from './pages/mantenimientos/planificacion/MantenimientoInsumos';
import MantenimientoRecetas from './pages/mantenimientos/planificacion/MantenimientoRecetas';
import MantenimientoTipoComponenteMenu from './pages/mantenimientos/planificacion/MantenimientoTipoComponenteMenu';
import MantenimientoMenusCiclicos from './pages/mantenimientos/planificacion/MantenimientoMenusCiclicos';

// PROCESOS - ALIMENTACIÓN
import GestionarTurnos from './pages/procesos/alimentacion/GestionarTurnos';
import GestionErroresCargaMasiva from './pages/procesos/alimentacion/GestionErroresCargaMasiva';
import CargaMasivaComensales from './pages/procesos/alimentacion/CargaMasivaComensales';
import CargaMasivaDietas from './pages/procesos/alimentacion/CargaMasivaDietas';
import CargaMasivaActivarComensales from './pages/procesos/alimentacion/CargaMasivaActivarComensales';
import SistemaOfflineContingencia from './pages/procesos/alimentacion/SistemaOfflineContingencia';
import CargaExternaAtenciones from './pages/procesos/alimentacion/CargaExternaAtenciones';
import TrasladoComensalesComedor from './pages/procesos/alimentacion/TrasladoComensalesComedor';
import NivelarAccesoComensalesComedor from './pages/procesos/alimentacion/NivelarAccesoComensalesComedor';
import HomologacionComensalesLogiflex from './pages/procesos/alimentacion/HomologacionComensalesLogiflex';
import CargarComensalesLogiflex from './pages/procesos/alimentacion/CargarComensalesLogiflex';
import TrasladoTurnosDetalleServicio from './pages/procesos/alimentacion/TrasladoTurnosDetalleServicio';

// PROCESOS - PLANIFICACIÓN DE INSUMOS
import ProgramacionMenuCiclico from './pages/procesos/planificacion-insumos/ProgramacionMenuCiclico';

// PROCESOS - HOTELERÍA
import CheckinCheckout from './pages/procesos/hoteleria/CheckinCheckout';
import CheckoutManual from './pages/procesos/hoteleria/CheckoutManual';
import CargaMasivaTrabajadores from './pages/procesos/hoteleria/CargaMasivaTrabajadores';
import AsignacionCamasTrabajadores from './pages/procesos/hoteleria/AsignacionCamasTrabajadores';
import ReservaManualCamas from './pages/procesos/hoteleria/ReservaManualCamas';
import CheckInManual from './pages/procesos/hoteleria/CheckInManual';
import EliminarCheckIn from './pages/procesos/hoteleria/EliminarCheckIn';
import CargaMasivaCamas from './pages/procesos/hoteleria/CargaMasivaCamas';
import EstadoCampamento from './pages/procesos/hoteleria/EstadoCampamento';
import EstadoCamasProyecto from './pages/procesos/hoteleria/EstadoCamasProyecto';
import GestionInfraestructura from './pages/procesos/hoteleria/GestionInfraestructura';
import EliminarReservas from './pages/procesos/hoteleria/EliminarReservas';
import HomologacionCamasLogiflex from './pages/procesos/hoteleria/HomologacionCamasLogiflex';
import ConciliacionCamas from './pages/procesos/hoteleria/ConciliacionCamas';
import InventarioAlojamientoLogiflex from './pages/procesos/hoteleria/InventarioAlojamientoLogiflex';
import SincronizacionReservasLogiflex from './pages/procesos/hoteleria/SincronizacionReservasLogiflex';
import GestionReservas from './pages/procesos/hoteleria/GestionReservas';
import GestionCheckIn from './pages/procesos/hoteleria/GestionCheckIn';
import GestionCheckOut from './pages/procesos/hoteleria/GestionCheckOut';
import HousekeepingDiario from './pages/procesos/hoteleria/HousekeepingDiario';
import CambioHabitacion from './pages/procesos/hoteleria/CambioHabitacion';

// REPORTES
import ReportesIndex from './pages/reportes/ReportesIndex';
import GenerarReporteAtencionPorComedor from './pages/reportes/ReporteAtencionComedor';
import GenerarReporteComensales from './pages/reportes/ReporteComensalesComedor';
import ReporteConsolidadoConsumosPorComensal from './pages/reportes/ReporteConsolidadoConsumosPorComensal';
import ReporteConsolidadoConsumosPorComensalCampamento from './pages/reportes/ReporteConsolidadoConsumosPorComensalCampamento';
import ReporteConsolidadoConsumosPorFechas from './pages/reportes/ReporteConsolidadoConsumosPorFechas';
import ConsultaAtencionesComensales from './pages/reportes/ConsultaAtencionesComensales';
import ReporteComensalesDietas from './pages/reportes/ReporteComensalesDietas';
import ReporteMenusCiclicos from './pages/reportes/ReporteMenusCiclicos';
import ResumenCorporativo from './pages/reportes/ResumenCorporativo';
import Depositos from './pages/corporativo/Depositos';
import EliminarDepositos from './pages/corporativo/EliminarDepositos';
import CentrosCosto from './pages/corporativo/CentrosCosto';
import TiposDeposito from './pages/corporativo/TiposDeposito';
import ProveedoresCorporativo from './pages/corporativo/ProveedoresCorporativo';
import Beneficiarios from './pages/corporativo/Beneficiarios';
import MantenimientoBancos from './pages/corporativo/MantenimientoBancos';
import MantenimientoMetodosPago from './pages/corporativo/MantenimientoMetodosPago';
import ClientesFacturacion from './pages/corporativo/ClientesFacturacion';
import FacturasVenta from './pages/corporativo/FacturasVenta';
// REPORTES - PLANIFICACIÓN DE INSUMOS
import ReporteInsumos from './pages/reportes/planificacion-insumos/ReporteInsumos';
import ReporteRecetas from './pages/reportes/planificacion-insumos/ReporteRecetas';
import ReporteProgramacionMenuCiclico from './pages/reportes/planificacion-insumos/ReporteProgramacionMenuCiclico';
import ReporteDepositosCorporativo from './pages/reportes/ReporteDepositosCorporativo';
// REPORTES - HOTELERÍA
import ReporteTrabajadores from './pages/reportes/hoteleria/ReporteTrabajadores';
import ReporteCamas from './pages/reportes/hoteleria/ReporteCamas';
import ReporteAsignaciones from './pages/reportes/hoteleria/ReporteAsignaciones';
import ReporteCheckouts from './pages/reportes/hoteleria/ReporteCheckouts';
import ReporteCheckins from './pages/reportes/hoteleria/ReporteCheckins';
import ReporteReservas from './pages/reportes/hoteleria/ReporteReservas';
import ReporteModificacionesReservas from './pages/reportes/hoteleria/ReporteModificacionesReservas';
import ReporteHabitabilidad from './pages/reportes/hoteleria/ReporteHabitabilidad';
import ReporteValorizacionHoteleria from './pages/reportes/hoteleria/ReporteValorizacionHoteleria';
import ReporteHistorialHuesped from './pages/reportes/hoteleria/ReporteHistorialHuesped';
// RECURSOS HUMANOS
import Empleados from './pages/rrhh/Empleados';
import Remuneraciones from './pages/rrhh/Remuneraciones';
import CargaMasivaEmpleados from './pages/rrhh/CargaMasivaEmpleados';
import RegimenesLaborales from './pages/rrhh/RegimenesLaborales';
import ParametriaPlanilla from './pages/rrhh/ParametriaPlanilla';
import Ruster from './pages/rrhh/Ruster';
import HomologacionBoletas from './pages/rrhh/HomologacionBoletas';
import CargaBoletasPlanilla from './pages/rrhh/CargaBoletasPlanilla';
import GeneracionBoletas from './pages/rrhh/GeneracionBoletas';
import Planilla from './pages/rrhh/Planilla';
// CONSULTAS
import ConsultaDniReniec from './pages/consultas/generales/ConsultaDniReniec';
import ConsultaComensalesDuplicados from './pages/consultas/alimentacion/ConsultaComensalesDuplicados';
import ConsultaServiciosDuplicadosComensales from './pages/consultas/alimentacion/ConsultaServiciosDuplicadosComensales';
import ConsultaHistorialHuesped from './pages/consultas/hoteleria/ConsultaHistorialHuesped';
import ConsultaCamasDisponibles from './pages/consultas/hoteleria/ConsultaCamasDisponibles';
import ReporteServiciosDuplicadosComensales from './pages/reportes/ReporteServiciosDuplicadosComensales';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {
  isCorporativoProject,
  isHoteleriaRoute,
  CORPORATIVO_ALLOWED_PATHS,
} from './utils/projectRouteAccess';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || 'null');

  // Si no hay token, redirigir al login
  if (!token) {
    return <Navigate to="/" />;
  }

  // Si no hay proyecto seleccionado, redirigir al login para seleccionar
  if (!selectedProject) {
    return <Navigate to="/" />;
  }

  // Contexto Corporativo: solo rutas permitidas; Hotelería exige proyecto de campamento
  if (isCorporativoProject(selectedProject)) {
    const pathname = window.location.pathname;

    if (isHoteleriaRoute(pathname)) {
      return (
        <Navigate
          to="/"
          replace
          state={{ requireCampamentoProject: true, from: pathname }}
        />
      );
    }

    const isAllowedPath = CORPORATIVO_ALLOWED_PATHS.some((path) =>
      pathname.startsWith(path)
    );
    if (!isAllowedPath) {
      return <Navigate to="/resumen-corporativo" />;
    }
  }

  // Si es proyecto normal y está en rutas corporativas específicas, redirigir
  // Pero permitir acceso a /corporativo/depositos desde cualquier proyecto
  if (selectedProject.tipo === 'proyecto' && (window.location.pathname === '/resumen-corporativo' || window.location.pathname === '/depositos')) {
    return <Navigate to="/gestionar-turnos" />;
  }

  return (
    <Layout>
      {children}
    </Layout>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <GestionarTurnos />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/gestionar-turnos"
          element={
            <PrivateRoute>
              <GestionarTurnos />
            </PrivateRoute>
          }
        />
        {/* Ruta legacy para compatibilidad */}
        <Route
          path="/gestionar-turnos"
          element={
            <PrivateRoute>
              <GestionarTurnos />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/errores-carga-masiva"
          element={
            <PrivateRoute>
              <GestionErroresCargaMasiva />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-comensales"
          element={
            <PrivateRoute>
              <MantenimientoComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/carga-masiva-comensales"
          element={
            <PrivateRoute>
              <CargaMasivaComensales />
            </PrivateRoute>
          }
        />
        {/* Ruta legacy para compatibilidad */}
        <Route
          path="/carga-masiva-comensales"
          element={
            <PrivateRoute>
              <CargaMasivaComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/carga-masiva-dietas"
          element={
            <PrivateRoute>
              <CargaMasivaDietas />
            </PrivateRoute>
          }
        />
        {/* Ruta legacy para compatibilidad */}
        <Route
          path="/carga-masiva-dietas"
          element={
            <PrivateRoute>
              <CargaMasivaDietas />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/carga-masiva-activar-comensales"
          element={
            <PrivateRoute>
              <CargaMasivaActivarComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/sistema-offline-contingencia"
          element={
            <PrivateRoute>
              <SistemaOfflineContingencia />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/carga-externa-atenciones"
          element={
            <PrivateRoute>
              <CargaExternaAtenciones />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/traslado-comensales-comedor"
          element={
            <PrivateRoute>
              <TrasladoComensalesComedor />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/nivelar-acceso-comensales-comedor"
          element={
            <PrivateRoute>
              <NivelarAccesoComensalesComedor />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/homologacion-comensales-logiflex"
          element={
            <PrivateRoute>
              <HomologacionComensalesLogiflex />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/carga-comensales-logiflex"
          element={
            <PrivateRoute>
              <CargarComensalesLogiflex />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/alimentacion/traslado-turnos-detalle"
          element={
            <PrivateRoute>
              <TrasladoTurnosDetalleServicio />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/planificacion-insumos/programacion-menu-ciclico"
          element={
            <PrivateRoute>
              <ProgramacionMenuCiclico />
            </PrivateRoute>
          }
        />
        {/* Ruta legacy para compatibilidad */}
        <Route
          path="/sistema-offline-contingencia"
          element={
            <PrivateRoute>
              <SistemaOfflineContingencia />
            </PrivateRoute>
          }
        />

        {/* PROCESOS - HOTELERÍA */}
        <Route
          path="/procesos/hoteleria/checkin-checkout"
          element={
            <PrivateRoute>
              <CheckinCheckout />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/checkout-manual"
          element={
            <PrivateRoute>
              <CheckoutManual />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/carga-masiva-trabajadores"
          element={
            <PrivateRoute>
              <CargaMasivaTrabajadores />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/reserva-automatica-camas"
          element={
            <PrivateRoute>
              <AsignacionCamasTrabajadores />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/reserva-manual-camas"
          element={
            <PrivateRoute>
              <ReservaManualCamas />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/check-in-manual"
          element={
            <PrivateRoute>
              <CheckInManual />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/eliminar-check-in"
          element={
            <PrivateRoute>
              <EliminarCheckIn />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/eliminar-reservas"
          element={
            <PrivateRoute>
              <EliminarReservas />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/estado-campamento"
          element={
            <PrivateRoute>
              <EstadoCampamento />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/estado-camas-proyecto"
          element={
            <PrivateRoute>
              <EstadoCamasProyecto />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/housekeeping-diario"
          element={
            <PrivateRoute>
              <HousekeepingDiario />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/cambio-habitacion"
          element={
            <PrivateRoute>
              <CambioHabitacion />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/carga-masiva-camas"
          element={
            <PrivateRoute>
              <CargaMasivaCamas />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/homologacion-camas-logiflex"
          element={
            <PrivateRoute>
              <HomologacionCamasLogiflex />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/conciliacion-camas"
          element={
            <PrivateRoute>
              <ConciliacionCamas />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/inventario-alojamiento-logiflex"
          element={
            <PrivateRoute>
              <InventarioAlojamientoLogiflex />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/sincronizacion-reservas-logiflex"
          element={
            <PrivateRoute>
              <SincronizacionReservasLogiflex />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/gestion-reservas"
          element={
            <PrivateRoute>
              <GestionReservas />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/gestion-checkin"
          element={
            <PrivateRoute>
              <GestionCheckIn />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/gestion-check-out"
          element={
            <PrivateRoute>
              <GestionCheckOut />
            </PrivateRoute>
          }
        />
        <Route
          path="/procesos/hoteleria/infraestructura"
          element={
            <PrivateRoute>
              <GestionInfraestructura />
            </PrivateRoute>
          }
        />

        {/* CONSULTAS — GENERALES */}
        <Route
          path="/consultas/generales/dni-reniec"
          element={
            <PrivateRoute>
              <ConsultaDniReniec />
            </PrivateRoute>
          }
        />
        <Route
          path="/consultas/alimentacion/comensales-duplicados"
          element={
            <PrivateRoute>
              <ConsultaComensalesDuplicados />
            </PrivateRoute>
          }
        />
        <Route
          path="/consultas/alimentacion/servicios-duplicados"
          element={
            <PrivateRoute>
              <ConsultaServiciosDuplicadosComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/consultas/hoteleria/historial-huesped"
          element={
            <PrivateRoute>
              <ConsultaHistorialHuesped />
            </PrivateRoute>
          }
        />
        <Route
          path="/consultas/hoteleria/camas-disponibles"
          element={
            <PrivateRoute>
              <ConsultaCamasDisponibles />
            </PrivateRoute>
          }
        />

        <Route
          path="/mantenimiento-clientes"
          element={
            <PrivateRoute>
              <MantenimientoClientes />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-proyectos"
          element={
            <PrivateRoute>
              <MantenimientoProyectos />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-proyectos-clientes"
          element={
            <PrivateRoute>
              <MantenimientoProyectosClientes />
            </PrivateRoute>
          }
        />
        {/* MANTENIMIENTOS - ALIMENTACIÓN */}
        <Route
          path="/mantenimientos/alimentacion/comedores"
          element={
            <PrivateRoute>
              <MantenimientoComedores />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/lectoras"
          element={
            <PrivateRoute>
              <MantenimientoLectoras />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/comedor-lectores-offline"
          element={
            <PrivateRoute>
              <MantenimientoComedorLectoresOffline />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/comensales"
          element={
            <PrivateRoute>
              <MantenimientoComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/tipo-servicios-alimentacion"
          element={
            <PrivateRoute>
              <MantenimientoTipoServiciosAlimentacion />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/tipo-servicios-comedor"
          element={
            <PrivateRoute>
              <MantenimientoTipoServiciosComedor />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/tipos-origen-trabajadores"
          element={
            <PrivateRoute>
              <MantenimientoTiposOrigenTrabajadores />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/tipos-servicios-alimentacion-origen"
          element={
            <PrivateRoute>
              <MantenimientoTiposServiciosAlimentacionOrigen />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/alimentacion/homologacion-excel"
          element={
            <PrivateRoute>
              <MantenimientoHomologacionExcel />
            </PrivateRoute>
          }
        />

        {/* MANTENIMIENTOS - HOTELERÍA */}
        <Route
          path="/mantenimientos/hoteleria/zonas"
          element={
            <PrivateRoute>
              <MantenimientoZonas />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/modulos"
          element={
            <PrivateRoute>
              <MantenimientoModulos />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/tipos-valorizacion"
          element={
            <PrivateRoute>
              <MantenimientoTiposValorizacionHoteleria />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/parametria-modulos"
          element={
            <PrivateRoute>
              <MantenimientoParametriaModulos />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/habitaciones"
          element={
            <PrivateRoute>
              <MantenimientoHabitaciones />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/camas"
          element={
            <PrivateRoute>
              <MantenimientoCamas />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/trabajadores"
          element={
            <PrivateRoute>
              <MantenimientoTrabajadoresHoteleria />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/parametria-carga-masiva-trabajadores"
          element={
            <PrivateRoute>
              <MantenimientoParametriaCamposTrabajadores />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/estructura-impresion-ticket"
          element={
            <PrivateRoute>
              <MantenimientoEstructuraTicket />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/hoteleria/estaciones-impresion"
          element={
            <PrivateRoute>
              <EstacionesImpresion />
            </PrivateRoute>
          }
        />

        {/* MANTENIMIENTOS - PLANIFICACIÓN DE INSUMOS */}
        <Route
          path="/mantenimientos/planificacion/familias-insumos"
          element={
            <PrivateRoute>
              <MantenimientoFamiliasInsumos />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/planificacion/subfamilias-insumos"
          element={
            <PrivateRoute>
              <MantenimientoSubfamiliasInsumos />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/planificacion/unidades-medida"
          element={
            <PrivateRoute>
              <MantenimientoUnidadesMedida />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/planificacion/insumos"
          element={
            <PrivateRoute>
              <MantenimientoInsumos />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/planificacion/recetas"
          element={
            <PrivateRoute>
              <MantenimientoRecetas />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/planificacion/tipos-componente-menu"
          element={
            <PrivateRoute>
              <MantenimientoTipoComponenteMenu />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/planificacion/menus-ciclicos"
          element={
            <PrivateRoute>
              <MantenimientoMenusCiclicos />
            </PrivateRoute>
          }
        />

        {/* RUTAS COMPATIBILIDAD - ALIMENTACIÓN */}
        <Route
          path="/mantenimiento-comedores"
          element={
            <PrivateRoute>
              <MantenimientoComedores />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-lectoras"
          element={
            <PrivateRoute>
              <MantenimientoLectoras />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-comensales"
          element={
            <PrivateRoute>
              <MantenimientoComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-tipo-servicios-alimentacion"
          element={
            <PrivateRoute>
              <MantenimientoTipoServiciosAlimentacion />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-tipo-servicios-comedor"
          element={
            <PrivateRoute>
              <MantenimientoTipoServiciosComedor />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes"
          element={
            <PrivateRoute>
              <ReportesIndex />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/alimentacion/atencion-por-comedor"
          element={
            <PrivateRoute>
              <GenerarReporteAtencionPorComedor />
            </PrivateRoute>
          }
        />
        <Route
          path="/generar-reporte-atencion-por-comedor"
          element={<Navigate to="/reportes/alimentacion/atencion-por-comedor" replace />}
        />
        <Route
          path="/reportes/alimentacion/comensales-por-comedor"
          element={
            <PrivateRoute>
              <GenerarReporteComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/generar-reporte-comensales"
          element={
            <Navigate to="/reportes/alimentacion/comensales-por-comedor" replace />
          }
        />
        <Route
          path="/reportes/alimentacion/consolidado-consumos-comensal"
          element={
            <PrivateRoute>
              <ReporteConsolidadoConsumosPorComensalCampamento />
            </PrivateRoute>
          }
        />
        <Route
          path="/reporte-consolidado-consumos"
          element={
            <PrivateRoute>
              <ReporteConsolidadoConsumosPorComensal />
            </PrivateRoute>
          }
        />
        <Route
          path="/reporte-consolidado-consumos-fechas"
          element={
            <PrivateRoute>
              <ReporteConsolidadoConsumosPorFechas />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/alimentacion/consulta-atenciones-comensales"
          element={
            <PrivateRoute>
              <ConsultaAtencionesComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/consulta-atenciones-comensales"
          element={<Navigate to="/reportes/alimentacion/consulta-atenciones-comensales" replace />}
        />
        <Route
          path="/reportes/alimentacion/comensales-dietas"
          element={
            <PrivateRoute>
              <ReporteComensalesDietas />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/alimentacion/servicios-duplicados-comensales"
          element={
            <PrivateRoute>
              <ReporteServiciosDuplicadosComensales />
            </PrivateRoute>
          }
        />
        <Route
          path="/reporte-comensales-dietas"
          element={<Navigate to="/reportes/alimentacion/comensales-dietas" replace />}
        />
        <Route
          path="/reporte-menus-ciclicos"
          element={
            <PrivateRoute>
              <ReporteMenusCiclicos />
            </PrivateRoute>
          }
        />
        {/* REPORTES - PLANIFICACIÓN DE INSUMOS */}
        <Route
          path="/reportes/planificacion-insumos/insumos"
          element={
            <PrivateRoute>
              <ReporteInsumos />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/planificacion-insumos/recetas"
          element={
            <PrivateRoute>
              <ReporteRecetas />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/planificacion-insumos/programacion-menu-ciclico"
          element={
            <PrivateRoute>
              <ReporteProgramacionMenuCiclico />
            </PrivateRoute>
          }
        />
        {/* REPORTES - HOTELERÍA */}
        <Route
          path="/reportes/hoteleria/trabajadores"
          element={
            <PrivateRoute>
              <ReporteTrabajadores />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/camas"
          element={
            <PrivateRoute>
              <ReporteCamas />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/reporte-ocupabilidad"
          element={
            <PrivateRoute>
              <ReporteAsignaciones />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/checkouts"
          element={
            <PrivateRoute>
              <ReporteCheckouts />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/checkins"
          element={
            <PrivateRoute>
              <ReporteCheckins />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/reservas"
          element={
            <PrivateRoute>
              <ReporteReservas />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/modificaciones-reservas"
          element={
            <PrivateRoute>
              <ReporteModificacionesReservas />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/habitabilidad"
          element={
            <PrivateRoute>
              <ReporteHabitabilidad />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/valorizacion"
          element={
            <PrivateRoute>
              <ReporteValorizacionHoteleria />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/hoteleria/historial-huesped"
          element={
            <PrivateRoute>
              <ReporteHistorialHuesped />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes/corporativo/depositos"
          element={
            <PrivateRoute>
              <ReporteDepositosCorporativo />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/generales/parametros-generales"
          element={
            <PrivateRoute>
              <MantenimientoParametrosGenerales />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimientos/generales/empresa"
          element={
            <PrivateRoute>
              <MantenimientoEmpresa />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-usuarios"
          element={
            <PrivateRoute>
              <MantenimientoUsuarios />
            </PrivateRoute>
          }
        />
        <Route
          path="/mantenimiento-usuarios-proyectos"
          element={
            <PrivateRoute>
              <MantenimientoUsuariosProyectos />
            </PrivateRoute>
          }
        />
        <Route
          path="/resumen-corporativo"
          element={
            <PrivateRoute>
              <ResumenCorporativo />
            </PrivateRoute>
          }
        />
        <Route
          path="/depositos"
          element={
            <PrivateRoute>
              <Depositos />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/depositos"
          element={
            <PrivateRoute>
              <Depositos />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/eliminar-depositos"
          element={
            <PrivateRoute>
              <EliminarDepositos />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/centros-costo"
          element={
            <PrivateRoute>
              <CentrosCosto />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/tipos-deposito"
          element={
            <PrivateRoute>
              <TiposDeposito />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/proveedores"
          element={
            <PrivateRoute>
              <ProveedoresCorporativo />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/beneficiarios"
          element={
            <PrivateRoute>
              <Beneficiarios />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/bancos"
          element={
            <PrivateRoute>
              <MantenimientoBancos />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/metodos-pago"
          element={
            <PrivateRoute>
              <MantenimientoMetodosPago />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/clientes-facturacion"
          element={
            <PrivateRoute>
              <ClientesFacturacion />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/facturas-venta"
          element={
            <PrivateRoute>
              <FacturasVenta />
            </PrivateRoute>
          }
        />
        {/* Rutas de Seguridad Corporativa */}
        <Route
          path="/corporativo/seguridad/usuarios"
          element={
            <PrivateRoute>
              <MantenimientoUsuarios />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/seguridad/roles"
          element={
            <PrivateRoute>
              <GestionRoles />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/seguridad/permisos-roles"
          element={
            <PrivateRoute>
              <PermisosRoles />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/seguridad/menus-roles"
          element={
            <PrivateRoute>
              <MenusRoles />
            </PrivateRoute>
          }
        />
        <Route
          path="/corporativo/seguridad/usuarios-roles"
          element={
            <PrivateRoute>
              <AsignarRolesUsuarios />
            </PrivateRoute>
          }
        />

        {/* RECURSOS HUMANOS */}
        <Route
          path="/rrhh/empleados"
          element={
            <PrivateRoute>
              <Empleados />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/remuneraciones"
          element={
            <PrivateRoute>
              <Remuneraciones />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/carga-masiva-empleados"
          element={
            <PrivateRoute>
              <CargaMasivaEmpleados />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/regimenes-laborales"
          element={
            <PrivateRoute>
              <RegimenesLaborales />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/parametria"
          element={
            <PrivateRoute>
              <ParametriaPlanilla />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/ruster"
          element={
            <PrivateRoute>
              <Ruster />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/homologacion-boletas"
          element={
            <PrivateRoute>
              <HomologacionBoletas />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/carga-boletas-planilla"
          element={
            <PrivateRoute>
              <CargaBoletasPlanilla />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/generacion-boletas"
          element={
            <PrivateRoute>
              <GeneracionBoletas />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh/planilla"
          element={
            <PrivateRoute>
              <Planilla />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
